import React, { Component } from "react";
import "typeface-roboto";
import CssBaseline from "material-ui/CssBaseline";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import { withStyles } from "material-ui/styles";
import Snackbar from "material-ui/Snackbar";
import { API } from "./Constants";

import { Route, NavLink, HashRouter } from "react-router-dom";

import UsersPage from "./Users";
import Auth from "./Auth";
import SeasonsPage from "./Seasons";
import MediafilesPage from "./Mediafiles";
import BoatsPage from "./Boats";

const styles = (theme) => ({
  leftMenu: {
    padding: theme.spacing.unit * 2,
  },
  mainContent: {
    padding: theme.spacing.unit * 2,
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    const { classes } = props;
    this.classes = classes;
    this.state = {
      loggedIn: false,
      admin_email: null,
      error: null,
      errorSnackbarOpen: false,
      isLoggingIn: false,
    };
    this.handleUserLogIn = this.handleUserLogIn.bind(this);
    this.handleUserLogOut = this.handleUserLogOut.bind(this);
    this.handleCloseErrorSnackbar = this.handleCloseErrorSnackbar.bind(this);
  }

  componentWillMount() {
    Auth.isLoggedIn()
      .then((json) => {
        if (json) {
          this.setState({
            loggedIn: true,
            admin_email: json.data.attributes.email_address,
            error: false,
          });
        }
      })
      .catch((error) => {
        console.error("Failed to verify login status:", error);
        // User will remain logged out, which is a safe default
      });
  }

  /**
       test@foo.com
       FSJM1IeCYf9QhVZmtKrWu0Iz0Vg=
    **/
  handleUserLogIn(e) {
    e.preventDefault();

    // Validate inputs
    const email = this.refs.email_address.value.trim();
    const password = this.refs.password.value;

    if (!email) {
      this.setState({
        error: "Email address is required",
        errorSnackbarOpen: true,
      });
      return;
    }

    if (!password) {
      this.setState({
        error: "Password is required",
        errorSnackbarOpen: true,
      });
      return;
    }

    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.setState({
        error: "Please enter a valid email address",
        errorSnackbarOpen: true,
      });
      return;
    }

    this.setState({ isLoggingIn: true, error: null });

    Auth.login(email, password)
      .then((json) => {
        this.setState({
          loggedIn: true,
          admin_email: json.data.attributes.email_address,
          error: null,
          errorSnackbarOpen: false,
          isLoggingIn: false,
        });
      })
      .catch((error) => {
        console.error("Login error:", error);
        this.setState({
          error: error.message || "Login failed. Please try again.",
          errorSnackbarOpen: true,
          isLoggingIn: false,
        });
      });
  }

  handleUserLogOut() {
    Auth.logout();
    this.setState({
      loggedIn: false,
      admin_email: null,
      error: null,
      errorSnackbarOpen: false,
    });
  }

  handleCloseErrorSnackbar() {
    this.setState({ errorSnackbarOpen: false });
  }

  render() {
    let navigationSectionContent, routes;
    if (this.state.loggedIn) {
      navigationSectionContent = (
        <div>
          <Typography>Hi {this.state.admin_email}</Typography>
          <button onClick={this.handleUserLogOut}>
            <Typography>Log out</Typography>
          </button>
          <nav>
            <Typography variant="title">Navigation</Typography>
            <ul>
              <li>
                <NavLink to="/">
                  <Typography>Home</Typography>
                </NavLink>
              </li>
              <li>
                <NavLink to="/users">
                  <Typography>Users</Typography>
                </NavLink>
              </li>
              <li>
                <NavLink to="/seasons">
                  <Typography>Seasons</Typography>
                </NavLink>
              </li>
              <li>
                <NavLink to="/mediafiles">
                  <Typography>Media Files</Typography>
                </NavLink>
              </li>
              <li>
                <NavLink to="/boats">
                  <Typography>Boats</Typography>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      );
      routes = (
        <div>
          <Route exact path="/" component={HomePage} />
          <Route path="/users" component={UsersPage} />
          <Route path="/seasons" component={SeasonsPage} />
          <Route path="/mediafiles" component={MediafilesPage} />
          <Route path="/boats" component={BoatsPage} />
        </div>
      );
    } else {
      navigationSectionContent = (
        <div>
          <form onSubmit={this.handleUserLogIn}>
            <Typography>
              <label>
                Email Address{" "}
                <input
                  type="text"
                  ref="email_address"
                  placeholder="email"
                  disabled={this.state.isLoggingIn}
                  required
                />
              </label>
              <br />
              <label>
                Password{" "}
                <input
                  type="password"
                  ref="password"
                  placeholder="password"
                  disabled={this.state.isLoggingIn}
                  required
                />
              </label>
              <br />
              <button disabled={this.state.isLoggingIn}>
                {this.state.isLoggingIn ? "Logging in..." : "Log In"}
              </button>
            </Typography>
          </form>
          {this.state.error && (
            <Typography style={{ color: "red", marginTop: "10px" }}>
              {this.state.error}
            </Typography>
          )}
        </div>
      );
      routes = <Typography>Please log in</Typography>;
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <HashRouter>
          <Grid container>
            <Grid item sm={2} xs={12} className={this.classes.leftMenu}>
              <div>
                <header>
                  <Typography variant="headline">D2D Admin</Typography>
                </header>
                {navigationSectionContent}
                <div style={{ marginTop: "20px" }}>
                  <Typography align="center">API: {API}</Typography>
                  <Typography align="center">
                    Build tag: {process.env.REACT_APP_BUILD_TAG}
                  </Typography>
                  <Typography align="center">
                    Environment: {process.env.NODE_ENV}
                  </Typography>
                </div>
              </div>
            </Grid>

            <Grid item sm={10} xs={12} className={this.classes.mainContent}>
              {routes}
            </Grid>
          </Grid>
        </HashRouter>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          open={this.state.errorSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleCloseErrorSnackbar}
          message={<span>{this.state.error}</span>}
        />
      </React.Fragment>
    );
  }
}

class HomePage extends Component {
  render() {
    return <Typography>Home content</Typography>;
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js